<template>
  <div id="app"
       class="container-fluid p-0"
       role="grid">
    <header id="bar-top"
            class="row fixed-top bg-dark"
            role="grid">
      <div id="banner"
           class="w-100 d-flex justify-content-center align-items-end">
        <router-link :to="{ name: 'Connexion' }">
          <span class="sr-only">Lien vers page de profil</span>
          <img id="logoMonCompte"
               src="../assets/images/bt-espace-client.svg"
               alt="logo mon compte">
        </router-link>
      </div>
    </header>
    <main class="row w-100 h-100 m-0 main-row d-flex flex-nowrap"
          role="grid">
      <div class="col-12 px-0">
        <div id="twoNavs"
              class="row center pt-2">
          <div id="cgcNav"
                class="col-12 col-sm-6 d-flex flex-column justify-content-between">
            <router-link :to="{ name: 'IngenierieConseilPatrimoniaux' }"
                          class="row banner text-decoration-none mb-2 mx-auto">
              <img src="../assets/images/logo-CGcourtage.svg"
                    alt="Bannière CG Courtage"
                    class="mx-auto logo">
            </router-link>
            <nav class="mb-1">
              <ul class="list-group list-group-flush">
                <li class="list-group-item border-primary">
                  <router-link :to="{ name: 'IngenierieConseilPatrimoniaux' }"
                                class="h3 openSans-bold d-block text-dark text-center text-uppercase text-decoration-none">
                    INGÉNIERIE PATRIMONIALE
                  </router-link>
                </li>
                <li class="list-group-item border-primary">
                  <router-link :to="{ name: 'EpargneRetraite' }"
                                class="h3 openSans-bold d-block text-dark text-center text-uppercase text-decoration-none">
                    ÉPARGNE ET RETRAITE
                  </router-link>
                </li>
                <li class="list-group-item border-primary">
                  <router-link :to="{ name: 'AssurancePrevoyance' }"
                                class="h3 openSans-bold d-block text-dark text-center text-uppercase text-decoration-none">
                    ASSURANCES ET PRÉVOYANCE
                  </router-link>
                </li>
                <li class="list-group-item border-primary">
                  <router-link :to="{ name: 'FinancementImmobilierProfessionnels' }"
                                class="h3 openSans-bold d-block text-dark text-center text-uppercase text-decoration-none">
                    FINANCEMENTS IMMOBILIERS ET FINANCEMENTS PROFESSIONNELS
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>
          <div id="immoNav"
                class="col-12 col-sm-6 d-flex flex-column pt-2 pt-sm-0">
            <router-link :to="{ name: 'Achat', params: { typeSearched: 'bien' } }"
                          class="row banner text-decoration-none mb-2 mx-auto">
              <img src="../assets/images/logo-tolusimmo.svg"
                    alt="Bannière Tollus Immo"
                    class="mx-auto logo">
            </router-link>
            <nav class="mb-1">
              <ul class="list-group list-group-flush">
                <li class="list-group-item border-secondary">
                  <router-link class="h3 openSans-bold d-block text-dark text-center text-uppercase text-decoration-none"
                                :to="{ name: 'Achat', params: {typeSearched: 'bien'} }">
                    Acheter
                  </router-link>
                </li>
                <li class="list-group-item border-secondary">
                  <router-link class="h3 openSans-bold d-block text-dark text-center text-uppercase text-decoration-none"
                                :to="{ name: 'Vente' }">
                    Vendre
                  </router-link>
                </li>
                <li class="list-group-item border-secondary">
                  <router-link class="h3 openSans-bold d-block text-dark text-center text-uppercase text-decoration-none"
                                :to="{ name: 'Investir' }">
                    Investir
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="w-100 bg-dark">
          <div id="entrepriseDescriptif"
               class="row center py-5">
            <h3 class="col text-light text-center py-3 m-0">Proche de vous, l'entreprise indépendante et familiale met à votre
              disposition une synergie de compétences : <span class="text-secondary openSans-bold">"Patrimoine - Finance
                - Immobilier"</span></h3>
          </div>
        </div>
        <div v-cloak
             id="app">
          <div class="w-100 bg-grey">
            <div id="focusGroup" class="row center justify-content-center py-5">
              <h1 class="col-12 text-dark openSans-bold text-center w-100 mb-5">Focus</h1>
              <focus-preview v-for="(element, idx) in focusToInsert" :key="idx" :focus="element"></focus-preview>
              <router-link :to="{ name: 'InfosTolus' }"
                           class="col-12 h5 text-dark text-decoration-none text-uppercase text-center very-small-ls mx-auto mt-5">
                Voir toutes nos infos <img src="../assets/images/fleche-voir-toutes-nos-infos.svg" alt="picto flèche" class="ml-3 mb-2">
              </router-link>
            </div>
          </div>
          <div id="biensGroup" class="row center py-5">
            <h1 class="col-12 text-secondary openSans-bold text-center w-100">Derniers biens immobiliers</h1>
            <bien-preview v-for="(bien, idx) in biens" :key="idx" :bien="bien"></bien-preview>
            <router-link :to="{ name: 'Achat', params: {typeSearched: 'bien'} }"
                         class="h5 text-dark text-decoration-none text-uppercase very-small-ls mx-auto mt-5">
              Voir toutes nos annonces immobilières  <img src="../assets/images/fleche-voir-toutes-nos-infos.svg" alt="picto flèche" class="ml-3 mb-2">
            </router-link>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import DataApi from 'fm-data-api'
import { NavbarPlugin } from 'bootstrap-vue'
import { getFocus } from '../mixins/getFocus'

Vue.use(NavbarPlugin)

export default {
  name: 'Home',
  mixins: [getFocus],
  components: {
    BienPreview: () => import('../components/BienPreview.vue'),
    FocusPreview: () => import('../components/FocusPreview.vue')
  },
  data () {
    return {
      dataApi: {},
      focus: [],
      focusToInsert: [],
      biens: {},
      token: '',
      descriptif: ''
    }
  },
  computed: {
    label () {
      return ': ' + this.favoriteColor
    }
  },
  methods: {
    async getFocusAndAnnonces (zkpAdvert) {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.findRecords('W_Focus', { b_accueil: '1', 'foc_RBQ__Rubrique::d_nomRubrique': 'info' }, '', '', '4')
        .then((focusList) => {
          this.insertFocus(focusList)
        })

      const sort2 = [{
        fieldName: 'd_dateAnnonce',
        sortOrder: 'descend'
      }]
      this.dataApi.getRecords('W_Annonce', sort2, '', '3')
        .then((biensList) => {
          this.insertBiens(biensList)
        })
    },
    insertBiens (biensL) {
      const biensList = (biensL === undefined) ? [] : biensL

      if (Object.values(biensList).length > 0) {
        const biensToInsert = {}
        Object.entries(biensList).forEach(function ([index, value]) {
          const dataToInsert = value.fieldData
          dataToInsert.recordId = value.recordId
          biensToInsert[index] = dataToInsert
        })
        this.biens = biensToInsert
      } else {
        this.biens = {}
      }
    },
    insertFocus (focusL) {
      const focusList = (focusL === undefined) ? [] : focusL
      if (focusList.length > 0) {
        const focusToInsert = {}
        focusList.forEach(function (value, index) {
          const dataToInsert = Vue.removeLayout(value.fieldData)
          dataToInsert.recordId = value.recordId
          focusToInsert[index] = dataToInsert
        }, this)
        this.focusToInsert = focusToInsert
      } else {
        this.focusToInsert = {}
      }
    }
  },
  async beforeMount () {
    this.getFocusAndAnnonces(),

    await this.getFocus('', 'Accueil')
      .then(res => {
        this.focus = res
      })
  
  }
}
</script>

<style lang="scss" scoped>
$heigtBarTop: 5.2rem;

#bar-top {
  height: $heigtBarTop !important;

  #banner {
    z-index: 1000 !important;
    height: 5rem !important;
    background-position: left;
    background-size: cover;

    #logoMonCompte,
    a {
      width: auto;
      height: 5rem;
    }
  }
}

#bar-bottom {
  .navbar {
    .navbar-nav {
      margin: 0 auto !important;
    }

    width: 100% !important;

    .nav-link {
      position: relative;
      color: var(--light) !important;
      bottom: 0.4rem !important;
      padding: 0 2rem !important;
    }
  }
}

main {
  padding: $heigtBarTop 0 0 0 !important;
}

#navbarNavBottom ul li.nav-item a {
  padding: 1rem !important;
  margin: 0 !important;
}

@media (max-width: 575px) {
  #navbarNavBottom ul li.nav-item a.border-right {
    border-right: none !important;
    border-bottom: 1px solid var(--primary) !important;
  }
}

@media (max-width: 767px) {
  #banner {
    background-color: #fff;
  }
  #bar-bottom {
    .navbar-nav {
      .nav-item {
        .nav-link {
          width: 20rem !important;
          margin: 0 auto !important;
          padding-top: 0.4rem !important;
          padding-bottom: 0.4rem !important
        }
      }

      .nav-item:not(:last-of-type) {
        .nav-link {
          border-bottom: 1px solid var(--light) !important;
        }
      }
    }
  }
  #biensGroup,
  #focusGroup {
    min-width: 22.5rem !important;
    width: 60% !important;
  }
}

@media (min-width: 768px) {
  #banner {
    background-color: #fff;
  }
  #bar-bottom {
    .navbar {
      height: 2.9rem !important;

      .nav-item:not(:last-of-type) {
        height: 0.8rem !important;
        border-right: 1px solid var(--light) !important;
      }
    }
  }
}

#twoNavs {
  margin-bottom: 30px;
  .list-group-item {
    background: none !important;
  }
}

@media (min-width: 768px) {

  .bg-GreyPoints {
    margin: 0 auto !important;
    background-image: url('../assets/images/points.svg');
    background-repeat: repeat-x;
    background-position: bottom center;
  }

  #twoNavs {
    .banner {
      max-width: 38rem !important;
    }

    li {
      border-width: 0 0 2px !important;
    }

    img {
      height: 10.5rem;
      width: auto;
    }
  }
}

@media (max-width: 991px) {
  #twoNavs {
    img {
      width: auto;
      height: 8.4rem;
    }

    .h3,
    h3 {
      font-size: 1.7rem !important;
    }
  }
}

.focusTitle {
  p {
    padding-right: 7rem !important;
  }
}
.bannerLegend {
  min-height: 7.5rem;
}
.logo {
  max-height: 144px;
  width: auto;
}
</style>
